import React from 'react'
import { Row, Col } from "reactstrap"

const Headings = ({headingFocused}) => {

  return(   
    <Row className="mb-3 m-auto border-bottom set-scrollbox-width">
        
        <Col 
          xs={6} 
          className={`
            offset-21 d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "cutOffValue" ? "heading-focused" : "heading"}
          `}
        >         
          Brytpunkt  
        </Col>     
        <Col 
          xs={5} 
          className={`
            offset-1 d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "percent" ? "heading-focused" : "heading"}
          `}
        >         
          Procentsats 
        </Col>  
        <Col 
          xs={7} 
          className={`
            d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
            ${headingFocused === "amount" ? "heading-focused" : "heading"}
          `}
        >         
          Belopp     
        </Col>  

    </Row>    
  );
}
export default Headings;